import { NavigationTabItem } from '@/components/Common/NavigationTabs/UiModel';

export type OrderDetailUi = {
  navTabs: NavigationTabItem[];
};

export const initialState: OrderDetailUi = {
  navTabs: [],
};
